import {Image} from '.cache/__types__';
import {nonNullArray, propertyRequiredArray} from 'src/types/general';

export const fullName = (firstName: string, lastName: string) => `${firstName} ${lastName}`.trim();

export const prepareImages = (images: Image[]) => propertyRequiredArray(nonNullArray(images ?? []), ['url']).map((i) => i.url);
